import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserDinerGame from 'src/games/DinerGame/Main';

interface DinerGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class DinerGame extends React.Component<DinerGameProps> {
    constructor(props: DinerGameProps) {
        super(props);
        bindAllOfThis(this, DinerGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserDinerGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default DinerGame;



// WEBPACK FOOTER //
// ./src/pages/game/DinerGame.tsx